
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expenses",
      function () {
        return require("private-next-pages/expenses.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expenses"])
      });
    }
  